import { render, staticRenderFns } from "./ShareProjectTaskModal.vue?vue&type=template&id=21199ecd&"
import script from "./ShareProjectTaskModal.vue?vue&type=script&lang=js&"
export * from "./ShareProjectTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareProjectTaskModal.vue?vue&type=style&index=0&id=21199ecd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports